import { FC } from 'react';
import { TTip } from '../interfaces';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import renderTip from '.';

const SingleTip: FC<{ tip: TTip }> = ({ tip }) => {
  return <div className="px-8 pb-8">{renderTip(tip, true)}</div>;
};

const CarouselTip: FC<{ pages?: TTip[] }> = ({ pages }) => {
  return (
    <div className="min-h-[10rem] w-96">
      <Carousel
        autoPlay={false}
        infiniteLoop
        showThumbs={false}
        showArrows={true}
        // dynamicHeight={true}
        showStatus={false}
      >
        {pages && pages.map((page) => <SingleTip key={page.key} tip={page} />)}
      </Carousel>
    </div>
  );
};

export default CarouselTip;
